import { Component, Inject, OnInit } from '@angular/core';
import { BaseDatasourceComponent } from '../base-datasource/base-datasource.component';
import { Shared } from '@rubii/frontend-common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatasourceConnectionComponent } from '../../datasource-connection/datasource-connection.component';
import { GoogleUserProfileInterface } from '../../interfaces/GoogleUserProfileInterface';
import { GoogleAgencyInterface } from '../../interfaces/GoogleAgencyInterface';

@Component({
  selector: 'app-data-studio',
  templateUrl: './data-studio.component.html',
  styleUrls: ['./data-studio.component.scss']
})
export class DataStudioComponent extends BaseDatasourceComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dataSourceId: number, userProfilesOrAgencies: GoogleUserProfileInterface[] | GoogleAgencyInterface[], enabledDatasourceId: number, userDataStudioToken?: string, dataSourceLogo: string },
  private snackBar: MatSnackBar, 
  private dialogRef: MatDialogRef<DatasourceConnectionComponent>) {
    super();
  }

  ngOnInit() {
  }

  copyMessageToClipboard(content: string): void {
    const textarea = document.createElement('textarea');
    textarea.value = content;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
    this.openSnackBar(this.snackBar, 'Token copied', 'Close');
    console.log('Message copied to clipboard');
  }


}
